module.exports = __webpack_public_path__ + "resource/img/banner_help.jpg?724fffcae4d1d938855414d9f2a39160";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_help.jpg
// module id = 189
// module chunks = 36